import React from 'react';
import {
  Col, Form, Input, Row, Switch,
} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { GeneralSettingsFormProps } from '../types';
import ResetFieldButton from '../../../Common/ResetFieldButton';

const defaultValues = {
  reason: 'Wir machen gerade ein Update am Kundenportal und sind bald wieder erreichbar!',
  description: 'Wenn Du in der Zwischenzeit dringliche Anfragen hast, wende Dich bitte an unseren Kundenservice.',
};

const prefix: keyof GeneralSettingsFormProps = 'maintenance';

function MaintenanceConfig() {
  const form = useFormInstance();
  const isActiveWatch = Form.useWatch([prefix, 'active'], form);

  const handleResetReason = () => {
    form.setFieldValue([prefix, 'reason'], defaultValues.reason);
  };

  const handleResetDescription = () => {
    form.setFieldValue([prefix, 'description'], defaultValues.description);
  };

  return (
    // className="bordered-container"
    <div>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item
            label={(
              <div className="centered-content">
                Reason (Heading)
                <ResetFieldButton onClick={handleResetReason} />
              </div>
            )}
            name={[prefix, 'reason']}
            rules={isActiveWatch ? [{ required: true, message: 'Please enter reason text' }] : undefined}
          >
            {/* addonBefore="Reason (title)" */}
            <Input placeholder="Enter reason text" maxLength={200} />
          </Form.Item>
        </Col>
        <Col span={20}>
          <Form.Item
            label={(
              <div className="centered-content">
                Description
                <ResetFieldButton onClick={handleResetDescription} />
              </div>
            )}
            name={[prefix, 'description']}
            rules={isActiveWatch ? [{ required: true, message: 'Please enter description text' }] : undefined}
          >
            <Input.TextArea placeholder="Enter description" maxLength={600} showCount />
          </Form.Item>
        </Col>
        <Col style={{ width: '100px' }}>
          <Form.Item
            // label={index === 0 ? 'Visible' : ''}
            label="Is Active"
            name={[prefix, 'active']}
          >
            <Switch
              checkedChildren="Active"
              unCheckedChildren="Inactive"
              style={{ width: '76px' }}
              onChange={() => form.validateFields()}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}

export default MaintenanceConfig;
